import {
  GET_DASHBOARD,
  GET_DASHBOARD_SUCCESS,
  GET_DASHBOARD_FAIL,
  CLEAR_DASHBOARD,
} from "./actionTypes"

export const getDashboard = (options, history) => ({
  type: GET_DASHBOARD,
  payload: { options, history },
})

export const getDashboardSuccess = dashboard => ({
  type: GET_DASHBOARD_SUCCESS,
  payload: dashboard,
})

export const getDashboardFail = error => ({
  type: GET_DASHBOARD_FAIL,
  payload: error,
})

export const clearDashboard = () => ({
  type: CLEAR_DASHBOARD,
})
